import { Localized } from '../../locales/Localized';
import { getCurrentWeekday, Weekday } from '../../util/time'

export interface MenuHeaderState {
  openingHours?: { [key: number]: string };
  closingHours?: { [key: number]: string };
  message?: Localized<string>;
}

export class MenuHeader {
  private state: MenuHeaderState;

  constructor(state: MenuHeaderState) {
    this.state = state;
  }

  getOpeningHours(day: number): string {
    if (this.state.openingHours && day in this.state.openingHours) {
      return this.state.openingHours[day];
    }
    return "";
  }

  getClosingHours(day: number): string {
    if (this.state.closingHours && day in this.state.closingHours) {
      return this.state.closingHours[day];
    }
    return "";
  }

  getLocalizedMessage(): Localized<string> {
    return this.state.message ?? {};
  }

  getOpeningHoursForToday(): { openingHours: string, closingHours: string } | null {
    const todayWeekday = getCurrentWeekday();
    return this.getOpeningHoursForWeekday(todayWeekday);
  }

  getOpeningHoursForWeekday(weekday: Weekday): { openingHours: string, closingHours: string } | null {
    // Weekdays are counted Sun -> Sat, while opening hours are saved Mon -> Sun.
    const day = (weekday.valueOf() + 6) % 7;
    const openingHours = this.getOpeningHours(day)
    const closingHours = this.getClosingHours(day)
    if (!openingHours || !closingHours) {
      return null;
    }
    return { openingHours, closingHours };
  }

  getOpeningHoursList(): { weekday: Weekday, openingHours: string, closingHours: string }[] {
    return [Weekday.MONDAY,
    Weekday.TUESDAY,
    Weekday.WEDNESDAY,
    Weekday.THURSDAY,
    Weekday.FRIDAY,
    Weekday.SATURDAY,
    Weekday.SUNDAY].map(day => {
      const data = this.getOpeningHoursForWeekday(day);
      if (data === null) return null;
      return {
        weekday: day,
        openingHours: data.openingHours,
        closingHours: data.closingHours,
      };
    }).filter(v => !!v) as any;
  }
}